import { TTLCache } from '@isaacs/ttlcache';
import { revalidate as solidRevalidate } from '@solidjs/router';
import { isServer } from 'solid-js/web';
import type { PathsWithMethod } from 'openapi-typescript-helpers';
import type { paths } from './__generated__/database';

declare global {
	var __trCache: TTLCache<unknown, unknown> | null;
}

export function getCache() {
	globalThis.__trCache ??= isServer ? null : new TTLCache({ max: 50, ttl: 60_000 * 4 });
	return globalThis.__trCache;
}

export type CacheablePaths = PathsWithMethod<paths, 'get'>;

export async function revalidate(key?: CacheablePaths | Array<CacheablePaths> | void, force?: boolean) {
	const cache = getCache();
	if (!cache) {
		await solidRevalidate(key, force);
		return;
	}

	const cacheKeys = Array.from(cache.keys()) as Array<string>;
	if (key) {
		const keys = Array.isArray(key) ? key : [key];
		for (const key of keys) {
			if (key.includes('[')) {
				cache.delete(key);
			} else {
				cacheKeys.filter((k) => k.startsWith(`${key}[`) || k === key).forEach((key) => cache.delete(key));
			}
		}
	} else if (!key) {
		cache.clear();
	}

	await solidRevalidate(key, force);
}
